import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Row } from '../StyledComponents/Forms/Forms';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChart = ({ data, selectedBarFn, isDetailView, children }) => {
  let labels, dataset;

  if (Array.isArray(data)) {

    labels = data.map(item => `${item.Year}-${item.Month}`);
    dataset = {
      label: 'Eyeticket Count',
      data: data.map(item => item.StatusCount),
      backgroundColor: data.map(() => getRandomColor())
    };
  } else {

    labels = Object.keys(data || {});
    dataset = {
      label: 'Eyeticket Count',
      data: Object.values(data || {}),
      backgroundColor: labels.map(() => getRandomColor())
    };
  }

  const chartData = {
    labels,
    datasets: [dataset]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      }
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: (isDetailView ? "Year & Month" : "Status")
        }
      },
      y: {
        grid: {
          display: true,
        },
        title: {
          display: true,
          text: 'EyeTicket Count'
        },
        beginAtZero: true,
        ticks: {
          stepSize: 1
        }
      },
    },
    onClick: (event, elements) => {
      if (elements.length > 0 && !isDetailView) {
        const elementIndex = elements[0].index;
        const status = labels[elementIndex];
        selectedBarFn(status);
      }
    },
    onHover: (event, chartElement) => {
      if (chartElement[0]) {
        event.native.target.style.cursor = 'pointer';
      } else {
        event.native.target.style.cursor = 'default';
      }
    }
  };

  return (
    <div style={{ 
        padding: '15px', 
        backgroundColor: '#f9f9f9', 
        borderRadius: '8px', 
        border: '1px solid #ccc',
        boxSizing: 'border-box'}}>
      <Row>{children}</Row>
      <Bar options={options} data={chartData} />
    </div>
  );
};

function getRandomColor() {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export default BarChart;
